import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useIntl } from 'react-intl';

type ViewCountsTooltipContentProps = {
  unread: number;
  total: number;
};

function CountRow({
  label,
  value,
  emphasized = false,
}: {
  label: string;
  value: number;
  emphasized?: boolean;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography
        component="span"
        variant="caption"
        sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}
      >
        {label}
      </Typography>
      <Typography
        component="span"
        variant="caption"
        sx={{
          fontWeight: emphasized ? 700 : 600,
          fontVariantNumeric: 'tabular-nums',
          color: 'inherit',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

/** תוכן tooltip למוני תצוגת שיחות — לא נקראו + סה״כ */
const ViewCountsTooltipContent: React.FC<ViewCountsTooltipContentProps> = ({ unread, total }) => {
  const intl = useIntl();

  return (
    <Box sx={{ py: 0.25, minWidth: 136 }}>
      <Stack spacing={0.75} divider={<Divider flexItem sx={{ borderColor: 'divider' }} />}>
        <CountRow
          label={intl.formatMessage({
            id: 'sidebar.nav.views.counts.unread',
            defaultMessage: 'לא נקראו',
          })}
          value={unread}
          emphasized
        />
        <CountRow
          label={intl.formatMessage({
            id: 'sidebar.nav.views.counts.total',
            defaultMessage: 'סה״כ שיחות',
          })}
          value={total}
        />
      </Stack>
    </Box>
  );
};

export default ViewCountsTooltipContent;
